import { ListItemBadge } from "@components/ListItemCardCst/types";

interface ScoStatusDefinition {
  labelKey: string;
  variant: ListItemBadge["variant"];
}

const SCO_STATUS_BY_VALUE: Record<string, ScoStatusDefinition> = {
  completed: { labelKey: "completed", variant: "success" },
  passed: { labelKey: "passed", variant: "success" },
  incomplete: { labelKey: "incomplete", variant: "info" },
  failed: { labelKey: "failed", variant: "error" },
  "not attempted": { labelKey: "not-attempted", variant: "default" },
  unknown: { labelKey: "unknown", variant: "default" },
  browsed: { labelKey: "browsed", variant: "default" },
};

export const resolveScoStatus = (
  value?: string | null,
): ScoStatusDefinition | null =>
  value ? (SCO_STATUS_BY_VALUE[value.trim().toLowerCase()] ?? null) : null;
